export default function addClassOnInit($timeout) {
  'ngInject';

  return async function link($scope, $element, $attrs) {
    await $timeout(0, false);
    $element.addClass($attrs.addClassOnInit);
  };
}
